import { BANNER_HEIGHT, LOW_INVENTORY_QUANTITY, NAV_HEIGHT, TEXT, WAITLIST_TYPES } from '../../config/constants';
import { REVIEW_MIN } from './constants';
import { REVIEWS } from './QuestionsAndReviews/constants';
import smoothScroll from '../../utils/dom/smoothScroll';
var _TEXT$inventory = TEXT.inventory,
    almostGone = _TEXT$inventory.almostGone,
    comingSoon = _TEXT$inventory.comingSoon,
    fewLeft = _TEXT$inventory.fewLeft,
    jtwl = _TEXT$inventory.jtwl,
    soldOut = _TEXT$inventory.soldOut;
export var displayFitRating = function displayFitRating(colorway, reviewCount) {
  if (!colorway) {
    return false;
  }

  return reviewCount > REVIEW_MIN && colorway.variantStacks.length > 1;
};
export var getInOptimizeVariant = function getInOptimizeVariant(id, variantId) {
  var _window$google_optimi;

  var optimizeVariant = ((_window$google_optimi = window.google_optimize) === null || _window$google_optimi === void 0 ? void 0 : _window$google_optimi.get(id)) || false;
  return optimizeVariant && optimizeVariant === variantId;
};
export var getSizeUrgencyMessage = function getSizeUrgencyMessage(inventory) {
  if (inventory <= 0) {
    return "".concat(soldOut, ".");
  }

  if (inventory <= LOW_INVENTORY_QUANTITY) {
    return "".concat(fewLeft, "!");
  }

  return '';
}; // soldOutSizes COLORWAY - based on entirely sold out size of color

export var getUrgencyMessage = function getUrgencyMessage(_ref) {
  var comingSoon = _ref.comingSoon,
      sizes = _ref.sizes,
      soldOutSizes = _ref.soldOutSizes;
  var sizesLeft = sizes.length - soldOutSizes.length;
  var sizesLeftPercentage = soldOutSizes.length / sizes.length;
  var almostGoneThreshold = 0.45;

  if (comingSoon && sizesLeft <= 0) {
    return '';
  }

  if (sizesLeft <= 0) {
    return "".concat(soldOut, ".");
  } // If large percentage of sizes are sold out for colorway.


  if (sizesLeftPercentage >= almostGoneThreshold) {
    return "".concat(almostGone, "!");
  }

  return '';
};
export var getWaitlistMessage = function getWaitlistMessage(_ref2) {
  var inventory = _ref2.inventory,
      waitlistType = _ref2.waitlistType;
  var wtlstType = WAITLIST_TYPES[waitlistType];
  var joinAction = (wtlstType === null || wtlstType === void 0 ? void 0 : wtlstType.length) > 0 ? " \u2013 ".concat(jtwl) : '';

  if (inventory <= 0 && wtlstType === comingSoon) {
    return "".concat(comingSoon).concat(joinAction);
  }

  if (inventory <= 0) {
    return "".concat(soldOut).concat(joinAction);
  }

  return getSizeUrgencyMessage(inventory);
};
export var getPublishedStyledWithItems = function getPublishedStyledWithItems() {
  var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return items.map(function (_ref3) {
    var _edges$, _colorway$image, _colorway$color, _colorway$variantStac, _colorway$status;

    var _ref3$product = _ref3.product,
        absoluteUrl = _ref3$product.absoluteUrl,
        edges = _ref3$product.colorways.edges,
        key = _ref3$product.id,
        productImage = _ref3$product.image,
        productTitle = _ref3$product.title,
        faceout = _ref3.faceout;
    var colorway = faceout !== null && faceout !== void 0 ? faceout : (_edges$ = edges[0]) === null || _edges$ === void 0 ? void 0 : _edges$.node;
    var image = (_colorway$image = colorway === null || colorway === void 0 ? void 0 : colorway.image) !== null && _colorway$image !== void 0 ? _colorway$image : productImage;
    var subtitle = (_colorway$color = colorway === null || colorway === void 0 ? void 0 : colorway.color) !== null && _colorway$color !== void 0 ? _colorway$color : '';
    var title = productTitle;
    var variantStacks = (_colorway$variantStac = colorway === null || colorway === void 0 ? void 0 : colorway.variantStacks) !== null && _colorway$variantStac !== void 0 ? _colorway$variantStac : [];
    var status = (_colorway$status = colorway === null || colorway === void 0 ? void 0 : colorway.status) !== null && _colorway$status !== void 0 ? _colorway$status : false;
    return {
      absoluteUrl: absoluteUrl,
      image: image,
      key: key,
      sizes: [],
      subtitle: subtitle,
      status: status,
      title: title,
      variantStacks: variantStacks
    };
  }).filter(function (_ref4) {
    var status = _ref4.status;
    return status === 'PUBLISHED';
  });
};
export var scrollToReviews = function scrollToReviews(event) {
  var review = document.querySelector("#".concat(REVIEWS.id));
  if (!review) return;

  if (event && event.preventDefault) {
    event.preventDefault();
  }

  var _window = window,
      history = _window.history;
  history.pushState(null, null, "#".concat(REVIEWS.id));
  var top = review.offsetTop - NAV_HEIGHT - BANNER_HEIGHT;
  smoothScroll(top);
};
export default {
  scrollToReviews: scrollToReviews
};